<template>
  <div>
    <header-bar v-if="!readonly">
      {{ type === 'album' ? 'アルバム（2曲以上）': 'シングル' }}配信
    </header-bar>
    <div :class="{'page-block': isStepArea}">
      <div
        v-if="!readonly && isStepArea"
        class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">
          {{ showConfirmation
            ? 'リリース情報確認'
            : 'リリース情報登録 - 配信ストアの選択' }}
        </h3>
        <release-type-label :type="type" />
      </div>
      <div :class="[{'page-block__inner' : isStepArea},{'release-confirmation':showConfirmation}]">
        <release-step-area
          v-if="!readonly && isStepArea"
          :index="3">
          <div v-if="showConfirmation">
            {{ contentsIdOnly? 'Youtube Contents ID 利用確認' : 'リリース情報確認' }}
          </div>
          <div v-else>
            {{ contentsIdOnly? 'Youtube Contents ID 利用内容' : '配信ストアの選択' }}
          </div>
          <span
            v-if="showConfirmation"
            class="header-description">
            この段階ではまだリリース情報は登録されていません。<br />
            下記内容で間違いなければ<b>注意事項</b>を確認し、{{ isBtoB ? '「配信審査を依頼する」'
              : isUserDataComplete ? '「アカウント情報の確認へ」' : '「アカウント情報の登録へ」' }}
            ボタンをクリックして下さい。
          </span>
        </release-step-area>
        <release-information
          v-if="showConfirmation && isStepArea"
          :confirm-product-errors="confirmProductErrors"
          :confirm-track-errors="confirmTrackErrors"
          :confirm="true" />
        <release-distribution
          ref="releaseDistribution"
          :resetting="resetting"
          :readonly="readonly"
          :back-from-release="backFromRelease"
          @on-error-product="onProductErrorOccured"
          @on-error-track="onTrackErrorOccured"
          @changeConfirm="setConfirm"
          @isUserDataComplete="isUserDataComplete = $event"
          @back-from-release="backFromReleaseStatus"
          @is-confirmed="isConfirmedStatus"
          @stateDetected="setState"
          @show-step-area="showStepArea($event)" />
      </div>
    </div>
    <confirm-dialog
      name="backFromRelease"
      :is-shown="backFromRelease"
      title="ページを離れますか？"
      @closed="onBackCanceled"
      @default-clicked="onBackConfirmed"
      @cancel-clicked="onBackCanceled">
      <template #body>
        選択したストア情報は保存されません。<br />
        よろしいですか？
      </template>
    </confirm-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../../HeaderBar'
import ReleaseTypeLabel from '../ReleaseTypeLabel'
import ReleaseStepArea from '../StepArea'
import ReleaseDistribution from './ReleaseDistribution'
import ReleaseInformation from '../Step2/ReleaseInformation'
import ConfirmDialog from '../../../../components/ConfirmDialog'

export default {
  name: 'ReleaseStep3',
  components: {
    ConfirmDialog,
    ReleaseTypeLabel,
    HeaderBar,
    ReleaseStepArea,
    ReleaseDistribution,
    ReleaseInformation,
  },
  props: {
    resetting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      backFromRelease: false,
      readonly: false,
      showConfirmation: false,
      type: 'single',
      status: 0,
      contentsIdOnly: false,
      confirmProductErrors: {},
      confirmTrackErrors: {},
      isUserDataComplete: false,
      returnObject: {},
      isConfirmed: false,
      toRoute: '',
      isStepArea: true,
    }
  },
  computed: {
    ...mapGetters('auth', ['subscriptionDefaulted', 'subscriptionCarrierFeePending']),
  },
  mounted() {
    // added for showing account confirmation screen if back from payment screen
    const isReturned = window.sessionStorage.getItem('back_from_payment_page')
    if (isReturned) {
      this.isStepArea = false
    }
    // 支払い方法変更中ならば「マイリリース」に遷移
    if (this.subscriptionCarrierFeePending) {
      this.$router.push({ name: 'release-index' })
    } else if (this.$route.query.confirm) {
      this.showConfirmation = true
    }
  },
  beforeRouteLeave(to, from, next) {
    // 支払い方法変更中ならばダイアログを出さずに「マイリリース」に遷移させる
    if (this.subscriptionCarrierFeePending) {
      next()
    } else {
      this.toRoute = to.path
      if (to.path === '/client/login') next()
      if (!this.isConfirmed) this.$refs.releaseDistribution.getReturnState()
      if (!this.backFromRelease) next()
      else {
        next(false)
      }
    }
  },
  methods: {
    onBackConfirmed() {
      this.isConfirmed = true
      this.backFromRelease = false
      if (this.toRoute) this.$router.push(this.toRoute)
      else {
        this.$refs.releaseDistribution.onBackConfirmed()
      }
    },
    onBackCanceled() {
      this.toRoute = ''
      this.backFromRelease = false
    },
    setConfirm(value) {
      this.showConfirmation = value
    },
    backFromReleaseStatus(value) {
      this.backFromRelease = value.backFromRelease
    },
    isConfirmedStatus(value) {
      this.isConfirmed = value.isConfirmed
    },
    setState(value) {
      this.status = value.status
      this.type = value.type
      this.contentsIdOnly = value.contentsIdOnly
    },
    onProductErrorOccured(errors) {
      this.confirmProductErrors = errors
    },
    onTrackErrorOccured({ discIndex, trackIndex, errors }) {
      if (!this.confirmTrackErrors[discIndex]) {
        this.$set(this.confirmTrackErrors, discIndex, {})
      }
      this.$set(this.confirmTrackErrors[discIndex], trackIndex, errors)
    },
    showStepArea(event) {
      this.isStepArea = event
    },
  },
}
</script>

<style>
.header-description {
  border: 1px solid red;
  padding: 15px;
  margin-top: 20vm!important;
  color: #d32f2f;
}
</style>
